<template>
  <div>
    <v-layout row wrap justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
      <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
            <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Pasos para la calibración de los equipos</h1>    
            <h2 class="animated bounceIn dura-2">Equipo de prueba de gases </h2>
      </v-flex>
      <v-flex xs12 sm9 md7 mt-3  class="text-xs-left"> 
        <span><strong> Verificación y calibración de equipos</strong></span> 
        <p>
            A continuación, encontrarás la descripción del proceso de calibración que incluye los siguientes aspectos: <br> <span class="instruccion"> Haz clic en cada pestaña para desplegar la información. </span>
        </p>   
      </v-flex>   
  <v-flex  xs12 sm7 md7 mb-2 v-for="(elemento, i) in contExpand" :key="'expand'+i" >
        <div 
          class="item-btn-modal btn-caja hvr hvr" 
          @click="expandAction(i-1)"
          :class="{'btnexpandvisto2':vistos[i-1] }"
        >  
          <span>{{elemento.titulo}}</span> 
          <!-- <v-icon class="icon" size="30" color="#c7ee95" :class="{'icon-active':expand[i-1]}"
          >navigate_next</v-icon> -->
        </div>
        <v-expand-transition >
          <div class="cont-item-modal" v-show="expand[i-1]" >
            <p class="" v-html="elemento.texto">

            </p>
            <div v-for="(img, idx) in elemento.img"
                :key="idx"
              > 
              <img 
                v-if="img"
                class="cuadro animated flipInX mt-2"
                :src="require('../../assets/unidad2/'+img+'.png')"
                alt
                 
              />

            </div>
            <br />
            <p class=" text-xs-left" v-html="elemento.texto2"> </p>   
            <img v-if="i ==0"
              class="cuadro animated flipInX mt-2"
              :src="require('../../assets/unidad2/pantalla-3-3.png')"
              alt
            />
            <br />
            <ul v-if="i ==0" class=" items text-xs-left"><li>Muestran las alarmas de alta (High alarm): ver valores 2 alarma Ecopetrol:</li></ul>  
            <img v-if="i ==0"
              class="cuadro animated flipInX mt-2"
              :src="require('../../assets/unidad2/pantalla-3-4.png')"  
              alt
            /> 
            <br />
            <ul v-if="i ==0" class=" items text-xs-left ">
                <li>Fecha actual (Date) </li>
                <li>Fecha última calibración (Last cal) </li>
                <li>Progreso de calentamiento del sensor (sensor  warmut) </li>
                <li>Indicador de batería </li>
                <li>Las determinadas por el fabricante </li> 
            </ul>
            <!-- video slide2 -->
          <v-layout v-if="i ==1" wrap justify-center align-center>
          <v-flex xs12 sm7 md7 >
             <video :src="videoYoutube" buffered controls 
                       :width="widthVideo" 
                       :height="heightVideo" 
                       @ended="mostrarCerrar2=true" 
          ></video>
          <i>Fuente: Ecopetrol</i>
          </v-flex>
        </v-layout>
          </div>
        </v-expand-transition>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return { 
      dialogos: [ 
        '',
      ],
      variable:false,
      expand: Array(4).fill(false),
      modal: false,
      adelante: false,
      currentText: "0",
      widthVideo:'100%',
      //heightVideo:'292px',
      videoYoutube:'./videos/Encendido.mp4',
      contExpand: [
        {
          titulo: "Encendido del equipo (funcionamiento) ", //1
          texto: 
          "Encender el quipo en una atmósfera controlada “limpia de contaminantes” con el fin de: <li>El equipo realiza una autoevaluación</li> <li>Examina su pantalla </li><li>Alarma audible </li><li>Los LED de alarma parpadean </li><li>La alarma de vibración se dispara brevemente </li><li>Prueba de flujo de la bomba (Pump test) </li>",
          img: ["pantalla-3-2"],
          texto2:"Si la prueba falla, el equipo entra en falla y se apagará en 60 segundos, aproximadamente. <li>Muestran las alarmas de baja (Low alarm): ver valores 1 alarma Ecopetrol: </li>",
        },
        {
          titulo: "Configuración de aire fresco (fresh  air setup) ", //2
          texto:
            "No activar la opción de aire fresco a menos que se esté seguro de que se encuentra en una atmósfera limpia de contaminantes, de lo contrario, pueden generarse lecturas incorrectas, indicando que una atmósfera peligrosa es segura.  No usar la configuración de aire fresco como sustituto de la prueba de calibración.<br>Configuración Aire Fresco <br> <li>Programa todos los sensores: dar lectura Cero  en los contaminantes y rango de oxígeno. </li><li>Si pasa la configuración automáticamente, queda en modalidad  de medición. </li> ",
          img: ["pantalla-3-5"],
          texto2:"Si el instrumento falla en la configuración de aire fresco, repite el proceso; si falla una segunda vez, no utilices el equipo y contacta al fabricante o proveedor. <br><br> <strong>Nota:</strong> Si el instrumento detecta un gas peligroso, se ignorará la orden de configuración de aire fresco y la unidad entrará en estado de alarma.<br><br> El siguiente video muestra el encendido y la prueba de aire fresco del detector de gas. <p class='instruccion'>Haz clic para reproducir el video.</p> ",
        },
        {
          titulo: "Prueba funcional (Bump Test)", //3
          texto:
            "<strong>Verificación (prueba funcional o Bump Test) con gas patrón certificado</strong><br><br> Las verificaciones tienen un doble propósito:<br> <strong>1.</strong> Confirmar que un gas puede llegar al sensor o sensores. <br> <strong>2.</strong> Confirmar que el o los sensores pueden activar la alarma en caso de estar expuestos a un gas. <br><br> Si el instrumento pasa la verificación <strong>(Bump Test)</strong>, en la parte superior se mostrará el símbolo durante 24 horas: ",
          img: ["pantalla-3-6"],
          texto2:"Si el instrumento no pasa la verificación (Bump Test), calibra el instrumento. ",
        },
        {
          titulo: "Calibración (Cal) con gas patrón certificado ", //4
          texto:
            "Una Calibración regular con una concentración de gas patrón certificado actualiza el punto de referencia del instrumento, permitiéndole reproducir lecturas exactas.<br> Recuerda leer las recomendaciones indicadas en el manual  del fabricante: <li>Realizar una calibración de forma regular para garantizar la precisión.</li><li>Calibrar de  forma inmediata si el equipo no concluye la prueba de verificación con éxito.</li><li>Después de instalar un sensor, es necesario realizar una calibración.</li><li>Se debe realizar la verificación de los equipos en el momento en que:</li><ul class='items' style= 'list-style-type: circle'><li>Se golpee físicamente </li<li>Se expone a altos niveles de contaminantes: “activación de alarmas”.</li><li>Calibración del equipo antes de su uso cuando no se use el equipo por un tiempo.</li><li>Las determinadas por el fabricante</li></ul>  ",
          //img: ["pantalla-3-6"],
          texto2:" ",
        },
      ],

      iconos: [
        "Es una empresa líder dedicada al desarrollo de productos y conceptos diferenciados para segmentos específicos del mercado. Actualmente, logra dar servicio a 16 mil clientes, a través de 5 segmentos de negocio: centros de consumo, tiendas de conveniencia, barras de café, cafeterías y soluciones para autoservicios y mayoristas.<br><br> A pesar de que para Caffenio y su Director General, la ética y los valores son temas fundamentales, no contaban con un sistema para transmitírselo a sus trabajadores. Además, aunque los casos de falta de ética eran tratados de manera justa e imparcial, éstos no eran vistos de la misma manera por los denunciantes, pues suponían que habría una tendencia en favor de los supervisores o líderes.<br><br> Por este motivo decidieron implementar un canal de denuncia y promoverlo al interior de la empresa, su implementación les ha distinguido con una imagen más profesional, comprometida y segura dentro del mercado. De manera interna, les ha ayudado a mejorar su clima laboral.<br><br> <i>Caso extraído de Deloitte, Las Mejores Empresas Mexicanas, disponible en https://www2.deloitte.com/content/dam/Deloitte/mx/Documents/risk/Tips-Anonimos/Caso-Exito-Caffenio-2018.pdf, revisado el 8 de junio de 2020.</i>",
        "Es una empresa mexicana, fundada en 1991. Obtuvo los derechos de Disney en 1995 y con el paso del tiempo se consolidó como una empresa líder en el diseño y distribución de productos infantiles y juveniles.<br><br> Su cultura está basada en la ética e integridad por lo que es imprescindible contar con un blindaje que les permita detectar cualquier tipo de conducta diferente a sus valores por lo que cuentan con un Comité de Ética, Código de Ética y un sistema de atención y denuncia.<br><br> Su sistema brinda una guía a sus empleados de cómo actuar de forma honesta y tratar a cada colaborador, cliente, socio, proveedor y consumidor. Cualquiera de sus colaboradores puede levantar el teléfono, reportar cualquier situación anómala y tener la confianza de que un experto les atenderá de manera oportuna y de forma anónima. Gracias a sus prácticas es considerada como una de las mejores empresas mexicanas.<br><br> <i>Caso de éxito en Deloitte, disponible en https://www2.deloitte.com/mx/es/pages/risk/articles/Tips-Anonimos-Casos-de-exito.html, revisado el 8 de junio de 2020.</i> ",
      ],
      frase: "",
      vistos: Array(3).fill(false),
    };
  },
  methods: {
    expandAction(val) {
      this.expand = Array(4).fill(false);
      this.$set(this.expand, val, true);
      this.$set(this.vistos, val, true);
    },
  },

};
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import "../../sass/globals";
.tituloModal {
  text-align: left !important;
  font-size: 12px;
  margin-bottom: 5px;
}
li.btn-secondary,
li.btn-primary {
  padding: 10px;
  margin-bottom: 10px;
  color: #fff;
  font-size: 11px;
}
.item-btn-modal {
  color: $color-primary;
  border-radius: 4px 4px 0px 0px;
  text-align: left;
  .icon {
    float: right;
    transition: all 0.3s ease-out;
    transform: rotate(0deg);
  }
  span {
    // font-family: Poppins-Bold;
    color: white;
    text-align: left;
  }
}
.icon-active {
  transform: rotate(90deg) !important;
}
.cont-item-modal {
  padding: 5px 0px;
  padding: 10px;
  border-radius: 0px 0px 4px 4px;
  p {
    color: black;
   // font-size: 0.8rem;
    margin: 0;
    padding: 0;
    text-align: left;
  }
}
.btn-caja {
  //border-radius: 4px;
  background: #EDEDED;
  color: white;
  font-size: 14px;
  padding: 15px 15px; 
  align-items: left;
  span { 
    padding: 0;
    margin: 0;
    color: black;
    font-weight: bold;
  }
} 
.cuadro {
  margin-bottom: 5px;
}
.btnexpandvisto2 {
  background: $color-success;
}

</style>
